import TaxListCountryData from "../../../../component/tax-types/tax-list/TaxListCountry";

function TaxListCountry() {
  return (
    <div className="page-body">
      <TaxListCountryData />
    </div>
  );
}

export default TaxListCountry;
